import React from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { PEPVIGIL } from 'pages/dlops-dashboard/utils/constant';
import { Item, style } from '../../style';
import breadcrumbIcon from '../../../../assets/images/dlopsImages/arrow_forward.svg';

const Header = ({ handleNavigation, handleBack }) => (
    <Grid container>
        <Grid item xs={12}>
            <Typography variant="h5">
                <Item sx={style.subHeader}>
                    <div
                        style={{
                            marginTop: '8px',
                            fontSize: '14px',
                            textAlign: 'left',
                        }}
                        className="contentContainer"
                    >
                        <span>{PEPVIGIL}</span>
                        <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                        <span aria-hidden="true" style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={handleNavigation}>
                            Projects
                        </span>
                        <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                        <span aria-hidden="true" style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={handleBack}>
                            Create New Project
                        </span>
                        <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                        <span aria-hidden="true" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={handleBack}>
                            Create New Model
                        </span>
                        <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                        <span style={{ fontWeight: 'bold', color: '#005CBC' }}>Create New Model Tags</span>
                    </div>
                </Item>
            </Typography>
        </Grid>
    </Grid>
);

Header.propTypes = {
    handleNavigation: PropTypes.func.isRequired,
    handleBack: PropTypes.func.isRequired,
};

export default Header;
